export default defineNuxtPlugin((nuxtApp) => {
    const { colorMode, initializeDarkMode, updateDarkClass } = useDarkMode()
    const media = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-color-scheme: dark)') : null
    const onSystemChange = () => {
        if (colorMode.value === 'system') updateDarkClass()
    }
    const onStorageChange = (event: StorageEvent) => {
        // Clearing storage also returns to the system preference.
        if (event.key === 'colorMode' || event.key === null) initializeDarkMode()
    }

    // Keep server/client state identical during hydration; the head bootstrap
    // already applied the correct visual theme before the first paint.
    nuxtApp.hook('app:mounted', () => {
        initializeDarkMode()
        if (media?.addEventListener) media.addEventListener('change', onSystemChange)
        else media?.addListener(onSystemChange)
        window.addEventListener('storage', onStorageChange)
    })

    if (import.meta.hot) {
        import.meta.hot.dispose(() => {
            if (media?.removeEventListener) media.removeEventListener('change', onSystemChange)
            else media?.removeListener(onSystemChange)
            window.removeEventListener('storage', onStorageChange)
        })
    }
})
